import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DefaultOptionType } from 'antd/es/select';
import { objectToOptions } from 'src/utils/objectToOptions';

interface ClientInfo {
  selectedClientData: API.ClientDetailed;
  selectedClientAdmins: API.GroupMember[];
  clientOptions: DefaultOptionType[];
  totalClients: number;
  settingClient: boolean;
}

const initialState: ClientInfo = {
  selectedClientData: {
    address: '',
    admins: [],
    city: '',
    company_name: '',
    id: '', 
    org_nr: '',
    tenant_id: '',
    users: [], 
    zip_code: '',
    collect_settings: {
      internal_account: '',
      external_account_inbound: '',
      external_account_outbound: '',
      accounts_payable: '',
      id: '' 
    },
    expense_settings: {
      account_payable: '',
      multiple_rows: true,
      require_department: true,
      require_project: true,
      require_xgl: false,
      display_department: true,
      display_project: true,
      display_xgl: false,
      id: ''
    },
    engine_settings: {
      collect_guid: '',
      collect_file_path: '',
      collect_queue: '',
      expense_guid: '',
      expense_file_path: '',
      expense_queue: '',
      id: ''
    },
    client_settings: {
      fully_managed: false,
      id: ''
    },
    target_system: ''
  },
  selectedClientAdmins: [],
  clientOptions: [],
  totalClients: 0,
  settingClient: false
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    updateClientInfo(state, action: PayloadAction<API.ClientCollection>) {
        state.clientOptions = objectToOptions(action.payload.items, 'company_name','id');
        state.totalClients = action.payload.total;
    },
    updateSelectedClient(state, action: PayloadAction<API.ClientDetailed>) {
      state.selectedClientData = action.payload;
    },
    updateSelectedClientAdmins(state, action: PayloadAction<API.GroupMember[]>) {
      state.selectedClientAdmins = action.payload;
    },
    updateSettingClient(state, action: PayloadAction<boolean>) {
      state.settingClient = action.payload;
    }
  },
});

export const { updateSelectedClient, updateClientInfo, updateSettingClient, updateSelectedClientAdmins } = clientSlice.actions;
export default clientSlice.reducer;
export {initialState as clientInitialState};
